/**
 * Widerruf: „Teile der Bestellung“ → Zusatzfeld einblenden
 */
(function () {
  function init(root) {
    if (!root || root.dataset.tkWiderrufReady === '1') return;
    root.dataset.tkWiderrufReady = '1';

    var radios = root.querySelectorAll('[data-tk-widerruf-scope]');
    var partial = root.querySelector('[data-tk-widerruf-partial]');
    var partialInput = root.querySelector('[data-tk-widerruf-partial-input]');

    function sync() {
      var selected = root.querySelector('[data-tk-widerruf-scope]:checked');
      var isPartial = !!(selected && selected.getAttribute('data-tk-widerruf-scope') === 'teile');
      if (!partial) return;

      if (isPartial) {
        partial.hidden = false;
        if (partialInput) partialInput.setAttribute('required', 'required');
      } else {
        partial.hidden = true;
        if (partialInput) {
          partialInput.removeAttribute('required');
          partialInput.value = '';
        }
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', sync);
    });
    sync();
  }

  function boot() {
    document.querySelectorAll('[data-tk-widerruf]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
